// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__ofeFi","active":"Button_active__AOEhv","loading":"Button_loading__AuEU7","error":"Button_error__-9jcK"};